import { React, useState } from "react";

import config from "../store/config";
import { getCsrfToken } from '../store/config';
import { getSourceCode } from '../store/config';
import RequestForm from "./Forms/RequestForm";
import AddToCartForm from "./Forms/AddToCartForm";

function FormArea(props) {
  const [currentStep, setCurrentStep] = useState("Request");

    function addToCart(values) {
        // post updated donation here
        let cartSendItem = {
            Id: Number(props.donation.CartItemId),
            SkuId: props.donation.SKUID,
            Quantity: 1,
            Price: (values.amount == 'other') ? parseFloat(values.customAmount) : parseFloat(values.amount),
            CustomData: [
                { Name: 'HonoreeCaption', Value: props.donation.HonoreeCaption.split('<br />').join('') },
                { Name: 'Honoree', Value: values.honoree },
                { Name: 'SourceCode', Value: ((!config.settings.cartItemId) ? getSourceCode() : '') }
            ]
          };

          let addOrUpdateEndpoint = 'api/requests/AddItem';
          if(cartSendItem.Id) {
            addOrUpdateEndpoint = 'api/requests/UpdateItem';
          }

          const sendRequest = async () => {
            const csrfToken = getCsrfToken();
            const response = await fetch(
              config.settings.apiEndpoint + addOrUpdateEndpoint,
              {
                method: 'POST',
                credentials: "include",
                body: JSON.stringify(cartSendItem),
                headers: {
                  'Content-Type': 'application/json',
                  'X-CSRF-TOKEN': window.AntiForgeryToken
                }
              }
            );
      
            if (!response.ok) {
              throw new Error('Sending cart data failed.');
            }
      
            const data = await response.json();
      
            if(addOrUpdateEndpoint.indexOf('AddItem') > -1) {
              const cartItemElement = document.querySelector('.cartlink span');
              if(cartItemElement) {
                let cartItemCount = Number(cartItemElement.textContent);
                cartItemCount++;
                cartItemElement.textContent = cartItemCount;
              } else {
                const span = document.createElement("span");
                const node = document.createTextNode("1");
                span.appendChild(node);
                const cartLink = document.querySelector('.cartlink');
                if(cartLink) {
                  cartLink.appendChild(span);
                }
              }
            }
      
            return data;
          };
      
          try {
            const cartItemData = sendRequest();

            setCurrentStep('AddToCart');

          } catch (error) {
            console.log(error);
          }
        
    }

  return (
    <div>
      {currentStep === "Request" && <RequestForm donation={props.donation} onSubmit={addToCart} />}
      {currentStep === "AddToCart" && <AddToCartForm donation={props.donation} />}
    </div>
  );
}

export default FormArea;
